import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useTemplate } from "PFApp/hooks";

export const useActivityTemplate = () => {
  const activity = useCurrentActivity();

  return useTemplate(activity?.template_id);
};
